import { useEffect } from 'react';
import { hysteriFetch, wrappers } from 'hysterics';
import { useDispatch } from 'react-redux';
import {
	locationsLoading,
	locationsAdded,
	locationsFetchError,
	useLocationsState
} from '../features/locations/locationsSlice';
import { CLIENT_SIDE_TIMEOUT } from '../utils/constants';

const wrapperOptions = {
	[wrappers.retry.contextKey]: {
		retries: 0
	},
	[wrappers.circuitBreaker.contextKey]: {
		timeout: CLIENT_SIDE_TIMEOUT * 2
	},
	[wrappers.timeout.contextKey]: {
		timeout: CLIENT_SIDE_TIMEOUT * 2
	}
};

const childAccountsFetchWrapper = hysteriFetch(
	'ws-locations-list-proxy-fetch',
	wrapperOptions
);

const useFetchAccountsApi = () => {
	const { accountId, failedToLoadADD } = useLocationsState();
	const dispatch = useDispatch();

	useEffect(() => {
		const fetchAddAccounts = async () => {
			try {
				if (failedToLoadADD && accountId) {
					dispatch(locationsLoading());

					const endpoint = 'fetchAllLocations';
					const url = new URL(
						`/api/widget/ws-locations-list/${endpoint}`,
						window.location.origin
					);

					url.searchParams.set('accountId', accountId);
					const apiURL = url.pathname + url.search;
					const response = await childAccountsFetchWrapper(apiURL);

					dispatch(locationsAdded(response));
				}
			} catch (error) {
				dispatch(
					locationsFetchError(
						error?.message || 'Failed to fetch locations'
					)
				);
			}
		};
		fetchAddAccounts();
	}, [failedToLoadADD, accountId, dispatch]);
};

export default useFetchAccountsApi;
